import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, Response, Jsonp, URLSearchParams } from '@angular/http';
// import { User } from '../models/user';
import { AppConfig } from '../../app.config';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/switchMap';
import { Subject } from 'rxjs/Subject';
@Injectable()
export class DashboardService {
    constructor(private http: Http, private config: AppConfig, private _jsonp: Jsonp) { }
    getAllDashboardInsight(date) {
        return this.http.get(this.config.apiUrl + 'user/dashboard-insight?date=' + date.toISOString(),
            this.setHeaders()).map((response: Response) => response.json());
    }
    findDashboardLeadsBySuccessor(reqData: any) {
        return this.http.get(this.config.apiUrl + 'user/dashboard-lead-by-successor/' + reqData.id + '?date=' + reqData.date.toISOString(),
            this.setHeaders()).map((response: Response) => response.json());
    }
    findDashboardAssignmentBySuccessor(reqData: any) {
        return this.http.get(this.config.apiUrl + 'user/dashboard-assignment-by-successor/' + reqData.id + '?date=' + reqData.date.toISOString()
            , this.setHeaders()).map((response: Response) => response.json());
    }
    findDashboardVisitAssignmentBySuccessor(reqData: any) {
        return this.http.get(this.config.apiUrl + 'user/dashboard-assignment-visit-by-successor/' + reqData.id + '?date=' + reqData.date.toISOString()
            , this.setHeaders()).map((response: Response) => response.json());
    }
    findDashboardVisitLeadBySuccessor(reqData: any) {
        return this.http.get(this.config.apiUrl + 'user/dashboard-lead-visit-by-successor/' + reqData.id + '?date=' + reqData.date.toISOString()
            , this.setHeaders()).map((response: Response) => response.json());
    }
    findDashboardPendingPaymentBySuccessor(reqData: any) {
        return this.http.get(this.config.apiUrl + 'user/dashboard-pending-collection-by-successor/' + reqData.id + '?date=' + reqData.date.toISOString()
            , this.setHeaders()).map((response: Response) => response.json());
    }
    findDashboardPendingDepositionPaymentBySuccessor(reqData: any) {
        return this.http.get(this.config.apiUrl + 'user/dashboard-pending-deposition-by-successor/' + reqData.id + '?date=' + reqData.date.toISOString()
            , this.setHeaders()).map((response: Response) => response.json());
    }
    performanceInsight(date) {
        return this.http.get(this.config.apiUrl + 'user/performance-insight?date=' + date.toISOString(),
            this.setHeaders()).map((response: Response) => response.json());
    }
    findPerformanceBySuccessors(reqData: any) {
        return this.http.get(this.config.apiUrl + 'user/performance-by-successors/'
            + reqData.id + '/' + reqData.type + '?date=' + reqData.date.toISOString(),
            this.setHeaders()).map((response: Response) => response.json());
    }
    getNotificationCount() {
        return this.http.get(this.config.apiUrl + 'user/notification-count', this.setHeaders()).map((response: Response) => response.json());
    }
    getAllNotifications(isExport, page) {
        return this.http.get(this.config.apiUrl + 'user/notification?limit=10&page=' + page + '&export=' + isExport, this.setHeaders())
            .map((response: Response) => response.json());
    }
    private setHeaders(params?: any) {
        // create authorization header with jwt token
        let token = localStorage.getItem('token');
        if (token) {
            // console.log('token >>>' + token);
            let headers = new Headers({ 'x-roamingse-token': token });
            if (params)
                return new RequestOptions({ headers: headers, search: params });
            else
                return new RequestOptions({ headers: headers });
        } else {
            return new RequestOptions({});
        }
    }
}



// WEBPACK FOOTER //
// /home/ec2-user/jenkins/workspace/new-roamingse/prod/roamingse-frontend/src/app/shared/services/dashboard.service.ts